const styles = {
  loadingSkeleton: {
    height: "32px",
    borderRadius: "16px",
  },
  selected: {
    backgroundColor: "primary.main",
    color: "white",
    "&:hover": {
      backgroundColor: "primary.main",
    },
  },
};

export default styles;
